import { ValidateNested, IsDefined } from 'class-validator';
import { Type } from 'class-transformer';
import { ColorDto } from './ColorDto';

export class ColorCollectionDto {
  @IsDefined()
  @ValidateNested()
  @Type(() => ColorDto)
  color1!: ColorDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => ColorDto)
  color2!: ColorDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => ColorDto)
  color3!: ColorDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => ColorDto)
  color4!: ColorDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => ColorDto)
  color5!: ColorDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => ColorDto)
  color6!: ColorDto;

  // Index signature to allow dynamic access
  [key: string]: ColorDto;
}
